import React, { useState, useEffect } from 'react';

const ShimmerHighlight = ({
                              children,
                              isActive = false,
                              className = ''
                          }) => {
    const [isShimmering, setIsShimmering] = useState(false);

    useEffect(() => {
        setIsShimmering(isActive);
    }, [isActive]);

    const containerStyle = {
        position: 'relative',
        border: isShimmering ? '2px solid #1877f2' : 'none',
    };

    const shimmerStyle = {
        position: 'absolute',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        pointerEvents: 'none',
        backgroundImage: `linear-gradient(
            90deg,
            transparent 0%,
            rgba(24, 119, 242, 0.2) 15%,
            rgba(24, 119, 242, 0.4) 30%,
            rgba(24, 119, 242, 0.2) 45%,
            transparent 60%
        )`,
        backgroundSize: '200% 100%',
        animation: 'shimmerAnimation 2s infinite linear',
        zIndex: 1000,
        borderRadius: 'inherit',
        opacity: 0.7,
    };

    return (
        <div style={containerStyle} className={className}>
            {children}
            {isShimmering && <div style={shimmerStyle} />}
            <style>
                {`
                    @keyframes shimmerAnimation {
                        0% {
                            background-position: 200% 0;
                        }
                        100% {
                            background-position: -200% 0;
                        }
                    }
                `}
            </style>
        </div>
    );
};

export default ShimmerHighlight;